export const mapTemplateToConfigurator = template => {
  if (!template) return {};

  // Prefer nested data if available, otherwise fall back to top-level
  let parsedData = template?.data;
  if (parsedData && typeof parsedData === 'string') {
    try {
      parsedData = JSON.parse(parsedData);
    } catch (err) {
      // Keep parsedData null and continue with the raw template
      parsedData = null;
    }
  }

  const sourceData =
    parsedData && typeof parsedData === 'object' ? parsedData : template;
  const { id, ...dataWithoutId } = sourceData || {};

  const regmailBlock =
    sourceData && typeof sourceData.regmail === 'object'
      ? sourceData.regmail
      : null;

  let mappedSettings = {
    ...template,
    ...dataWithoutId,
    ownerId: template.owner_id,
    ownerUsername: template.ownerUsername,
  };

  if (parsedData && typeof parsedData === 'object') {
    mappedSettings.data = parsedData;
  }

  if (regmailBlock) {
    mappedSettings = {
      ...mappedSettings,
      ...regmailBlock,
      regmail: regmailBlock,
    };
  }

  // Normalize sectionTitles to expected shape if present
  const rawSectionTitles = Array.isArray(sourceData?.sectionTitles)
    ? sourceData.sectionTitles
    : Array.isArray(template?.sectionTitles)
      ? template.sectionTitles
      : Array.isArray(sourceData?.section_titles)
        ? sourceData.section_titles
        : null;

  if (rawSectionTitles) {
    mappedSettings.sectionTitles = rawSectionTitles.map((sec, idx) => ({
      id: sec.id ?? idx,
      text: sec.text ?? sec.title ?? '',
      body: sec.body ?? sec.content ?? sec.bodyText ?? '',
      color: sec.color ?? sec.colour ?? mappedSettings.linkColor ?? '#00519e',
      fontSize: sec.fontSize ?? 18,
      styles: Array.isArray(sec.styles) ? sec.styles : ['bold'],
      level: sec.level,
      cta: sec.cta ?? sec.ctaSlot ?? sec.ctaPlacement,
    }));
  }

  return mappedSettings;
};
